import { render } from "./IconTelegram.vue?vue&type=template&id=fd29a420"
import script from "./IconTelegram.vue?vue&type=script&lang=js"
export * from "./IconTelegram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__